<template>
  <div class="home-page">
    <!-- Banner轮播区域 -->
    <BannerSlider />

    <!-- 关于我们时间轴 -->
    <section class="timeline-section">
      <div class="container">
        <h2 class="section-title">关于我们</h2>
        <div class="timeline-wrapper">
          <div class="timeline-line"></div>
          <div class="timeline-items">
            <div class="timeline-item">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-year">1998年</div>
                <div class="timeline-desc">创业初始，坚持于润滑油与工业油生产领域</div>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-year">2003年</div>
                <div class="timeline-desc">长江润滑油品牌正式创立</div>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-year">2005年</div>
                <div class="timeline-desc">市场版图在全国17个省市，年产值突破两亿元</div>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-year">2007年</div>
                <div class="timeline-desc">工厂遭遇重大火灾，困境中仍顽强复工</div>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-year">2015年</div>
                <div class="timeline-desc">在工业油领域不断推陈出新</div>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-year">2025年</div>
                <div class="timeline-desc">中石油助力长江，革新而来</div>
              </div>
            </div>
            <div class="timeline-item">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-year">未来</div>
                <div class="timeline-desc">致力于打造民族润滑品牌新高度</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 品牌介绍 - PC端 -->
    <section class="brand-intro-section" v-if="!isMobile">
      <div class="container">
        <div class="brand-intro-content">
          <div class="brand-image">
            <img src="../assets/images/products-about.png" alt="长江品牌" />
          </div>
          <div class="brand-text">
            <h3 class="brand-tag">品牌简介</h3>
            <h2 class="brand-title">
              长江，成就时间淬炼的润滑史诗<br>
              央企实力背书，硬核品质保障
            </h2>
            <p class="brand-desc">
              长江机油前身始于1998年，2003年长江机油品牌正式创立，专注民用润滑油的研发与生产，完善优异品质，深耕车用及工程机械润滑领域。2025年，长江机油依托中石油集团旗下公司，凝聚国家级科研力量与匠心精神，以国之重器"稀土"赋能润滑保护，为引擎持久释放奔腾动力。
            </p>
            <button class="brand-btn" @click="goToBrandIntro">探索更多</button>
          </div>
        </div>
      </div>
    </section>

    <!-- 品牌介绍 - H5移动端 -->
    <section class="brand-intro-section brand-intro-mobile" v-if="isMobile">
      <div class="container">
        <h2 class="section-title">品牌简介</h2>
        <div class="brand-intro-content-mobile">
          <div class="brand-image-mobile">
            <img src="../assets/images/products-about.png" alt="长江品牌" />
          </div>
          <div class="brand-text-mobile">
            <h2 class="brand-title-mobile">
              长江，成就时间淬炼的润滑史诗<br>
              央企实力背书，硬核品质保障
            </h2>
            <p class="brand-desc-mobile">
              长江机油前身始于1998年，2003年长江机油品牌正式创立，专注民用润滑油的研发与生产，完善优异品质，深耕车用及工程机械润滑领域。2025年，长江机油依托中石油集团旗下公司，凝聚国家级科研力量与匠心精神，以国之重器"稀土"赋能润滑保护，为引擎持久释放奔腾动力。
            </p>
            <button class="brand-btn-mobile" @click="goToBrandIntro">探索更多</button>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品精选 -->
    <section class="products-section">
      <div class="container">
        <h2 class="section-title">产品精选</h2>
        
        <p class="section-desc">
          经典全合成润滑油，采用高端铁罐包装，搭配长江上下游风土地貌，在中国不同地貌的极端环境与严苛工况中反复淬炼产品。
<br>
独家添加稀土抗磨因子，可显著降低发动机关键运动部件的磨损、减少运动阻力，提升发动机响应速度，并降低燃油消耗
        </p>
        
        <!-- 产品标签切换 -->
        <div class="product-tabs">
          <button 
            v-for="category in productCategories"
            :key="category.id"
            class="tab-btn"
            :class="{ active: activeTab === category.id }"
            @click="switchCategory(category.id)"
          >
            {{ category.categoryName }}
          </button>
        </div>

        <!-- 产品展示 -->
        <div class="products-grid" v-show="!loading">
          <div 
            class="product-card" 
            v-for="product in currentProducts" 
            :key="product.id"
            @click="handleProductClick(product)"
            style="cursor: pointer;"
          >
            <div class="product-image">
              <img :src="product.image" :alt="product.name" />
            </div>
            <div class="product-info">
              <h3 class="product-title">
                <span class="product-series">{{ currentCategoryName }}<span v-if="product.desc">-{{ product.desc }}</span></span>
                <span class="product-name-red">{{ product.name }}</span>
              </h3>
              <!-- 产品标签 -->
              <div class="product-tags" v-if="product.tags && product.tags.length > 0">
                <span class="product-tag" v-for="(tag, tagIndex) in product.tags" :key="tagIndex">
                  {{ tag }}
                </span>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 加载中 -->
        <div v-if="loading" class="loading-products">
          加载中...
        </div>
        
        <!-- 没有产品时的提示 -->
        <div v-if="!loading && currentProducts.length === 0" class="no-products">
          暂无产品数据
        </div>

        <div class="products-more">
          <button class="more-btn" @click="goToProducts">探索更多</button>
        </div>
      </div>
    </section>

    <!-- 品牌优势 -->
    <section class="advantages-section">
      <div class="container">
        <h2 class="section-title advantages-title">品牌优势</h2>
        
        <div class="advantages-grid">
          <div class="advantage-card">
            <div class="advantage-icon">
              <img src="@/assets/images/ad1.png" alt="30年跨世纪民族品牌" />
            </div>
            <h3 class="advantage-title">30年跨世纪民族品牌</h3>
            <p class="advantage-desc">
              长江机油前身始于1998年，早期从事润滑油生产。2003年创立“长江”品牌，迅速拓展至全国17省市，年产值曾突破两亿元。2007年遭遇火灾重大挫折，但仍坚持复工。后十余年来，在工业油领域不断推陈出新。2025年依托中国石油的强大技术与资源，开启品牌涅槃重生的新篇章。
            </p>
          </div>

          <div class="advantage-card">
            <div class="advantage-icon">
              <img src="@/assets/images/ad2.png" alt="创新材料突破 首次研发稀土抗磨因子" />
            </div>
            <h3 class="advantage-title">创新材料突破 首次研发稀土抗磨因子</h3>
            <p class="advantage-desc">
              为提升动力体验，长江机油不断探索新材料，最终聚焦稀土关键元素——镧，创新研发稀土抗磨因子。镧作为“工业维生素”，是国家重要战略资源，广泛应用于航天、军工等领域。其强大氧化能力将油膜牢固附着于发动机表面，形成保护矩阵，抗磨率提升27.5%+，热稳定性极佳。
            </p>
          </div>

          <div class="advantage-card">
            <div class="advantage-icon">
              <img src="@/assets/images/ad3.png" alt="中石油合作研发 硬核品质保障" />
            </div>
            <h3 class="advantage-title">中石油合作研发 硬核品质保障</h3>
            <p class="advantage-desc">
              长江机油凝聚了中石油深厚技术积淀。中石油作为润滑油国家标准主导制定单位，累计获省部级科技奖34项、国家专利104项，成果351项。依托2大研发中心、6大基地、5个国家实验室及1578套精密设备，创新添加中国特有稀土元素，尽显科技实力与中国制造底蕴。
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- 媒体中心 -->
    <section class="media-section">
      <div class="container">
        <h2 class="section-title">媒体中心</h2>
        
        <!-- 加载状态 -->
        <div v-if="newsLoading" class="media-loading">
          <div class="loading-spinner"></div>
          <p>加载中...</p>
        </div>
        
        <!-- 新闻内容 -->
        <div v-else-if="topNews" class="media-content">
          <div class="media-left">
            <img :src="topNews.imageUrl" :alt="topNews.title" />
          </div>
          
          <div class="media-right">
            <h3 class="media-title">{{ topNews.title }}</h3>
            <p class="media-date">{{ topNews.date }}</p>
            <p class="media-desc">
              {{ extractTextFromHTML(topNews.content, 200) }}
            </p>
            <a href="javascript:;" class="media-link" @click="viewNewsDetail(topNews)">了解更多 →</a>
          </div>
        </div>
        
        <!-- 无数据 -->
        <div v-else class="media-empty">
          <p>暂无新闻</p>
        </div>
        
        <div class="media-more">
          <button class="more-btn" @click="exploreMore">探索更多</button>
        </div>
      </div>
    </section>

    <!-- 合作伙伴 -->
    <section class="partners-section">
      <div class="container">
        <h2 class="section-title">合作伙伴</h2>
        
        <div class="partners-header">
          <div class="partners-tabs">
            <button 
              v-for="category in partnerCategories"
              :key="category.dictCode"
              class="tab-btn"
              :class="{ active: partnerTab === category.dictValue }"
              @click="switchPartnerCategory(category.dictValue)"
            >
              {{ category.dictLabel }}
            </button>
          </div>
          
          <!-- 左右导航按钮：只在有数据时显示 -->
          <div class="partners-arrows" v-if="partnersList.length > 0">
            <button class="arrow-btn prev" @click="prevPartner">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button class="arrow-btn next" @click="nextPartner">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
        
        <!-- 专家团内容 (dictValue === '1') - 一行两个，左右滑动轮播 -->
        <div class="partners-content" v-if="partnerTab === '1' && !partnersLoading">
          <div 
            class="team-cards-carousel" 
            :class="{ 'single-card': partnersList.length === 1 }"
            v-if="partnersList.length > 0"
          >
            <!-- 显示当前页的两个专家（或一个） -->
            <div 
              v-for="(partner, index) in currentPagePartners"
              :key="partner.id"
              class="team-card"
              :class="{ 
                featured: (currentPartnerIndex + index) % 2 === 1,
                'single-team-card': partnersList.length === 1
              }"
            >
              <div class="team-card-inner">
                <div class="team-image">
                  <img :src="partner.image" :alt="partner.name" />
                  <div class="team-label">专家</div>
                </div>
                <div :class="(currentPartnerIndex + index) % 2 === 1 ? 'team-info-wrapper' : ''">
                  <div class="team-info">
                    <h3>{{ partner.name }}</h3>
                    <p class="team-subtitle">{{ partner.nameEn || 'Expert' }}</p>
                    <p class="team-desc">{{ partner.desc || '暂无介绍' }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="no-data">
            陆续上线中，敬请期待
          </div>
        </div>
        
        <!-- 高校/机构内容 (dictValue === '2') -->
        <div class="partners-content" v-if="partnerTab === '2' && !partnersLoading">
          <div class="institution-content" v-if="partnersList.length > 0 && partnersList[currentPartnerIndex]">
            <div class="institution-left">
              <img :src="partnersList[currentPartnerIndex].image" :alt="partnersList[currentPartnerIndex].name" />
              <div class="institution-label">机构</div>
            </div>
            <div class="institution-right">
              <h3>{{ partnersList[currentPartnerIndex].name }}</h3>
              <p class="institution-location">{{ partnersList[currentPartnerIndex].nameEn || '' }}</p>
              <p class="institution-desc">{{ partnersList[currentPartnerIndex].desc || '暂无介绍' }}</p>
              <div class="institution-dots">
                <span 
                  v-for="(item, idx) in partnersList" 
                  :key="item.id"
                  class="dot"
                  :class="{ active: idx === currentPartnerIndex }"
                  @click="currentPartnerIndex = idx"
                ></span>
              </div>
            </div>
          </div>
          <div v-else class="no-data">
            陆续上线中，敬请期待
          </div>
        </div>
        
        <!-- 加载中状态 -->
        <div class="partners-content" v-if="partnersLoading">
          <div class="loading-partners">
            加载中...
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BannerSlider from '@/components/BannerSlider.vue';

export default {
  name: 'Home',
  components: {
    BannerSlider
  },
  data() {
    return {
      activeTab: null, // 当前选中的分类ID
      partnerTab: '1', // 默认选中专家团（使用dictValue）
      currentPartnerIndex: 0,
      productCategories: [], // 产品分类列表
      products: [], // 当前分类的产品列表
      loading: false,
      // 合作伙伴相关数据
      partnerCategories: [], // 合作伙伴分类列表
      partnersList: [], // 当前分类的合作伙伴列表
      partnersLoading: false,
      // 媒体中心相关数据
      topNews: null, // 置顶新闻数据
      newsLoading: false,
      // 响应式布局
      isMobile: false
    };
  },
  computed: {
    currentProducts() {
      // 首页只展示前三个产品
      const products = this.products || [];
      return products.slice(0, 3);
    },
    // 当前选中的分类名称
    currentCategoryName() {
      const category = this.productCategories.find(cat => cat.id === this.activeTab);
      return category ? category.categoryName : '';
    },
    // 当前页显示的专家（一次显示2个，如果只有1个就显示1个）
    currentPagePartners() {
      if (this.partnerTab !== '1' || this.partnersList.length === 0) {
        return [];
      }
      
      // 如果只有1个专家，直接返回
      if (this.partnersList.length === 1) {
        return [this.partnersList[0]];
      }
      
      // 一次显示2个
      const startIndex = this.currentPartnerIndex;
      const endIndex = Math.min(startIndex + 2, this.partnersList.length);
      return this.partnersList.slice(startIndex, endIndex);
    }
  },
  async mounted() {
    // 初始化检查是否为移动端
    this.checkMobile();
    // 监听窗口大小变化
    window.addEventListener('resize', this.checkMobile);
    
    await Promise.all([
      this.fetchProductCategories(),
      this.fetchPartnerCategories(),
      this.fetchTopNews()
    ]);
  },
  beforeDestroy() {
    // 移除窗口监听
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    // 检查是否为移动端
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    
    // 获取产品分类
    async fetchProductCategories() {
      try {
        const res = await this.$api.product.getProductCategoryList();
        if (res.code === 200 && res.data) {
          this.productCategories = res.data;
          // 如果有分类，默认选中第一个
          if (this.productCategories.length > 0) {
            this.activeTab = this.productCategories[0].id;
            await this.fetchProducts(this.activeTab);
          }
        }
      } catch (error) {
        console.error('获取产品分类失败:', error);
      }
    },
    
    // 获取媒体(图片)完整URL - 与BannerSlider组件保持一致
    getMediaUrl(url) {
      // 与BannerSlider组件保持完全一致
      return process.env.VUE_APP_IMAGE_URL + url;
    },
    
    // 获取产品列表
    async fetchProducts(categoryId) {
      try {
        this.loading = true;
        const res = await this.$api.product.getProducts({
          publishLocation: 1, // 首页
          productCategory: categoryId
        });
        if (res.code === 200 && res.data) {
          // 处理产品数据，映射字段
          this.products = res.data.map(item => ({
            id: item.id,
            name: item.productName,
            model: item.productCarType || '新品', // 副标题/车型，如果没有则显示"新品"
            desc: item.productSellingPoints,
            image: item.productImage ? this.getMediaUrl(item.productImage) : require('../assets/images/product.png'),
            jumpUrl: item.jumpUrl,
            tags: item.tags || [] // 产品标签数组
          }));
        }
      } catch (error) {
        console.error('获取产品列表失败:', error);
        this.products = [];
      } finally {
        this.loading = false;
      }
    },
    
    // 切换产品分类
    async switchCategory(categoryId) {
      if (this.activeTab !== categoryId) {
        this.activeTab = categoryId;
        await this.fetchProducts(categoryId);
      }
    },
    
    // 处理产品点击
    handleProductClick(product) {
      if (product.jumpUrl) {
        // 如果有跳转链接，打开新窗口
        window.open(product.jumpUrl, '_blank');
      } else {
        // 否则跳转到产品详情页
        this.$router.push(`/product/${product.id}`);
      }
    },
    
    // 跳转到产品中心页面
    goToProducts() {
      this.$router.push('/products');
    },
    
    // 跳转到品牌介绍页面
    goToBrandIntro() {
      this.$router.push('/about');
    },
    
    // 获取合作伙伴分类
    async fetchPartnerCategories() {
      try {
        const res = await this.$api.dict.getFriendsCategory();
        if (res.code === 200 && res.data) {
          this.partnerCategories = res.data;
          // 如果有分类，默认选中第一个
          if (this.partnerCategories.length > 0) {
            this.partnerTab = this.partnerCategories[0].dictValue;
            await this.fetchPartnersList(this.partnerTab);
          }
        }
      } catch (error) {
        console.error('获取合作伙伴分类失败:', error);
      }
    },
    
    // 获取合作伙伴列表
    async fetchPartnersList(category) {
      try {
        this.partnersLoading = true;
        const res = await this.$api.friends.getFriendsByCategory(category);
        if (res.code === 200 && res.data) {
          this.partnersList = res.data.map(item => ({
            id: item.id,
            name: item.friendsName,
            nameEn: item.friendsNameEn,
            desc: item.friendsDesc,
            image: item.friendsUrl ? this.getMediaUrl(item.friendsUrl) : require('../assets/images/partners1.png'),
            sort: item.sort
          }));
          // 重置索引
          this.currentPartnerIndex = 0;
        }
      } catch (error) {
        console.error('获取合作伙伴列表失败:', error);
        this.partnersList = [];
      } finally {
        this.partnersLoading = false;
      }
    },
    
    // 切换合作伙伴分类
    async switchPartnerCategory(categoryValue) {
      if (this.partnerTab !== categoryValue) {
        this.partnerTab = categoryValue;
        await this.fetchPartnersList(categoryValue);
      }
    },
    
    prevPartner() {
      if (this.partnerTab === '1') {
        // 专家团：每次向前翻2个
        this.currentPartnerIndex = Math.max(0, this.currentPartnerIndex - 2);
      } else {
        // 高校机构：每次向前翻1个
        this.currentPartnerIndex = Math.max(0, this.currentPartnerIndex - 1);
      }
    },
    
    nextPartner() {
      if (this.partnersList.length === 0) return;
      
      if (this.partnerTab === '1') {
        // 专家团：每次向后翻2个，但不超过最大索引
        const maxIndex = Math.max(0, this.partnersList.length - 2);
        this.currentPartnerIndex = Math.min(maxIndex, this.currentPartnerIndex + 2);
      } else {
        // 高校机构：每次向后翻1个
        const maxIndex = this.partnersList.length - 1;
        this.currentPartnerIndex = Math.min(maxIndex, this.currentPartnerIndex + 1);
      }
    },
    
    // 获取置顶新闻
    async fetchTopNews() {
      try {
        this.newsLoading = true;
        const res = await this.$api.news.getTopNews();
        console.log('首页置顶新闻响应:', res);
        
        if (res.code === 200 && res.data) {
          const newsData = res.data;
          // 处理富文本中的图片URL
          let processedContent = this.processRichTextImages(newsData.content);
          
          this.topNews = {
            id: newsData.id,
            title: newsData.title,
            imageUrl: newsData.imageUrl ? this.getMediaUrl(newsData.imageUrl) : require('../assets/images/media-center.png'),
            content: processedContent, // 处理后的HTML内容
            // 格式化日期显示
            date: newsData.startTime || newsData.createTime?.split(' ')[0] || '2024-12-27'
          };
        }
      } catch (error) {
        console.error('获取置顶新闻失败:', error);
        // 使用默认数据
        this.topNews = {
          title: '长江机油搭载稀土科技在途虎上线，适配从豪华到家用全场景',
          imageUrl: require('../assets/images/media-center.png'),
          content: '长江机油以中华民族母亲河——长江为名正式创立，自诞生起便带着"为每台发动机精准配油满足方案"的初心，在润滑领域深耕细作，专注为各类车辆及工程机械提供最佳保护。定制化的服务，无论是豪华轿车的动力需求，还是家用车的节能诉求，长江机油始终相伴，好的润油，应当像"营养餐"一样，适配不同发动机的"口味"。',
          date: '2024-12-27'
        };
      } finally {
        this.newsLoading = false;
      }
    },
    
    // 处理富文本中的图片URL
    processRichTextImages(html) {
      if (!html) return '';
      
      // 获取基础URL
      const baseUrl = process.env.VUE_APP_IMAGE_URL || 'http://45.192.98.104:8080';
      
      // 替换所有的相对路径图片为绝对路径
      let processed = html.replace(/src="(\/[^"]+)"/g, (match, url) => {
        // 如果已经是完整的URL，不处理
        if (url.startsWith('http://') || url.startsWith('https://')) {
          return match;
        }
        // 拼接基础URL
        return `src="${baseUrl}${url}"`;
      });
      
      return processed;
    },
    
    // 截取HTML内容的纯文本（用于显示摘要）
    extractTextFromHTML(html, maxLength = 200) {
      if (!html) return '';
      // 创建一个临时div来解析HTML
      const div = document.createElement('div');
      div.innerHTML = html;
      const text = div.textContent || div.innerText || '';
      // 截取指定长度
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },
    
    // 查看新闻详情
    viewNewsDetail(news) {
      if (news && news.id) {
        this.$router.push({ name: 'BlogDetail', params: { id: news.id } });
      }
    },
    
    // 探索更多 - 跳转到新闻详情页
    exploreMore() {
      this.$router.push('/blog');
      // if (this.topNews && this.topNews.id) {
      //   this.$router.push({ name: 'BlogDetail', params: { id: this.topNews.id } });
      // } else {
      //   // 如果没有新闻数据，跳转到媒体中心列表
      //   this.$router.push('/blog');
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.home-page {
  min-height: 100vh;
}

/* 通用样式 */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
}

.section-title {
  font-size: 42px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 80px;
  color: #333;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    width: 160px;
    height: 48px;
    background: url('../assets/images/title-bottom-bg.png') center/contain no-repeat;
  }

  @media (max-width: 768px) {
    font-size: 28px;
    margin-bottom: 60px;
    
    &::after {
      width: 120px;
      height: 36px;
      bottom: -20px;
    }
  }
}

/* 时间轴部分 */
.timeline-section {
  padding: 80px 0;
  background: #f8f9fa;

  .timeline-wrapper {
    position: relative;
    padding: 40px 0;
  }

  .timeline-line {
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    height: 2px;
    background: #ddd;
  }

  .timeline-items {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
  }

  .timeline-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    min-width: 0;
    padding-top: 40px;
    
    &.active {
      .timeline-year {
        color: #ed1c24;
      }
      
      .timeline-desc {
        color: #ed1c24;
        font-weight: 500;
      }
    }
  }

  .timeline-dot {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 20px;
    background: #fff;
    border: 3px solid #ed1c24;
    border-radius: 50%;
    z-index: 2;
    
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 10px;
      height: 10px;
      background: #ed1c24;
      border-radius: 50%;
    }
  }

  .timeline-content {
    text-align: center;
    padding: 0 10px;
    margin-top: 20px;
    
    .timeline-year {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 8px;
    }
    
    .timeline-desc {
      font-size: 13px;
      color: #666;
      line-height: 1.5;
      max-width: 156px;
      margin: 0 auto;
    }
  }

  @media (max-width: 992px) {
    .timeline-wrapper {
      overflow-x: auto;
      padding: 60px 20px;
    }

    .timeline-items {
      min-width: 900px;
    }
  }

  @media (max-width: 768px) {
    padding: 60px 0;

    .timeline-wrapper {
      overflow-x: auto;
      padding: 60px 20px 40px;
      -webkit-overflow-scrolling: touch;
    }

    .timeline-line {
      top: 38px;
      width: 800px;
      right: auto;
    }

    .timeline-items {
      min-width: 800px;
    }

    .timeline-item {
      min-width: 110px;
      padding-top: 30px;
    }

    .timeline-dot {
      width: 16px;
      height: 16px;
      top: -29px;
      
      &::after {
        width: 8px;
        height: 8px;
      }
    }

    .timeline-content {
      margin-top: 0;
      
      .timeline-year {
        font-size: 17px;
      }
      
      .timeline-desc {
        font-size: 14px;
        max-width: 100px;
      }
    }
  }
}

/* 品牌介绍部分 - PC端 */
.brand-intro-section {
  padding: 100px 0;
  background: #fff;

  .brand-intro-content {
    display: flex;
    align-items: center;
    gap: 80px;

    @media (max-width: 992px) {
      flex-direction: column;
      gap: 40px;
    }
  }

  .brand-image {
    flex: 1;
    
    img {
      width: 100%;
      height: auto;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    }
  }

  .brand-text {
    flex: 1;

    .brand-tag {
      color: #ed1c24;
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 20px;
    }

    .brand-title {
      font-size: 36px;
      font-weight: bold;
      color: #333;
      line-height: 1.4;
      margin-bottom: 30px;

      @media (max-width: 768px) {
        font-size: 24px;
        margin-bottom: 20px;
      }
    }

    .brand-desc {
      font-size: 16px;
      color: #666;
      line-height: 1.8;
      margin-bottom: 40px;
    }

    .brand-btn {
      padding: 14px 40px;
      background: linear-gradient(135deg, #ed1c24 0%, #c91118 100%);
      color: #fff;
      border: none;
      border-radius: 30px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
        transition: left 0.5s ease;
      }

      &:hover {
        background: linear-gradient(135deg, #ff4545 0%, #ed1c24 100%);
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(237, 28, 36, 0.4);
        
        &::before {
          left: 100%;
        }
      }
    }
  }
}

/* 品牌介绍部分 - H5移动端 */
.brand-intro-mobile {
  padding: 60px 0;

  .brand-intro-content-mobile {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .brand-image-mobile {
    img {
      width: 100%;
      height: auto;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    }
  }

  .brand-text-mobile {
    .brand-title-mobile {
      font-size: 24px;
      font-weight: bold;
      color: #333;
      line-height: 1.4;
      margin-bottom: 20px;
    }

    .brand-desc-mobile {
      font-size: 16px;
      color: #666;
      line-height: 1.8;
      margin-bottom: 40px;
    }

    .brand-btn-mobile {
      padding: 14px 40px;
      background: linear-gradient(135deg, #ed1c24 0%, #c91118 100%);
      color: #fff;
      border: none;
      border-radius: 30px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
        transition: left 0.5s ease;
      }

      &:hover {
        background: linear-gradient(135deg, #ff4545 0%, #ed1c24 100%);
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(237, 28, 36, 0.4);
        
        &::before {
          left: 100%;
        }
      }
    }
  }
}

/* 产品精选部分 */
.products-section {
  padding: 100px 0;
  background: url('../assets/images/products-select-bg.png') center center no-repeat;
  background-size: cover;
  position: relative;

  .container {
    position: relative;
    z-index: 2;
  }

  .section-desc {
    // text-align: center;
    font-size: 15px;
    line-height: 1.8;
    color: #666;
    max-width: 900px;
    margin: -20px auto 40px;
  }

  .product-tabs {
    display: flex;
    justify-content: center;
    margin-bottom: 60px;
    
    .tab-btn {
      width: 180px;
      padding: 12px 0;
      background: #f5f5f5;
      border: none;
      font-size: 16px;
      font-weight: 500;
      color: #666;
      cursor: pointer;
      transition: all 0.3s ease;
      text-align: center;

      &:first-child {
        border-radius: 8px 0 0 8px;
        
        &.active {
          background: linear-gradient(270deg, #A31C20 0%, #DF0414 100%);
          color: #fff;
          border-radius: 8px 0 0 8px;
        }
      }
      
      &:last-child {
        border-radius: 0 8px 8px 0;
        
        &.active {
          background: linear-gradient(270deg, #A31C20 0%, #DF0414 100%);
          color: #fff;
          border-radius: 0 8px 8px 0;
        }
      }

      &:hover:not(.active) {
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }

  .products-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
    margin-bottom: 60px;

    @media (max-width: 992px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
    }

    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 15px;
    }
  }

  .product-card {
    background: #fff;
    overflow: visible;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    position: relative;

    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
      
      .product-image {
        background: #f0f0f0;
      }
    }

    .product-image {
      width: 100%;
      height: 380px;
      background: #fafafa;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      position: relative;
      transition: background 0.3s ease;

      @media (max-width: 768px) {
        height: 200px;
      }

      img {
        width: auto;
        height: 85%;
        object-fit: contain;

        @media (max-width: 768px) {
          height: 75%;
        }
      }
    }

    .product-info {
      padding: 20px;
      background: #fff;

      @media (max-width: 768px) {
        padding: 12px;
      }

      .product-title {
        margin-bottom: 12px;
        line-height: 1.4;
        text-align: left;
        display: flex;
        align-items: baseline;
        gap: 8px;
        flex-wrap: wrap;

        @media (max-width: 768px) {
          margin-bottom: 8px;
          gap: 4px;
        }

        .product-series {
          font-size: 14px;
          font-weight: 500;
          color: #333;

          @media (max-width: 768px) {
            font-size: 11px;
          }
        }

        .product-name-red {
          font-size: 18px;
          font-weight: bold;
          color: #ed1c24;

          @media (max-width: 768px) {
            font-size: 14px;
          }
        }
      }
      
      .product-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 12px;

        @media (max-width: 768px) {
          gap: 5px;
          margin-top: 8px;
        }
        
        .product-tag {
          display: inline-block;
          padding: 4px 10px;
          background: #f5f5f5;
          color: #666;
          font-size: 12px;
          border-radius: 3px;
          border: 1px solid #e8e8e8;
          transition: all 0.2s ease;

          @media (max-width: 768px) {
            padding: 3px 8px;
            font-size: 10px;
          }
          
          &:hover {
            background: #ed1c24;
            color: #fff;
            border-color: #ed1c24;
          }
        }
      }
    }
  }

  .loading-products,
  .no-products {
    text-align: center;
    padding: 60px 20px;
    color: #999;
    font-size: 16px;
  }

  .products-more {
    text-align: center;

    .more-btn {
      padding: 14px 50px;
      background: #ed1c24;
      color: #fff;
      border: none;
      border-radius: 30px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: darken(#ed1c24, 10%);
        transform: translateY(-2px);
        box-shadow: 0 5px 15px rgba(237, 28, 36, 0.3);
      }
    }
  }

  @media (max-width: 768px) {
    padding: 60px 0;

    .section-desc {
      padding: 0 20px;
      font-size: 14px;
      margin: -10px auto 30px;
    }

    .product-tabs {
      margin-bottom: 40px;
      
      .tab-btn {
        width: 140px;
        padding: 10px 0;
        font-size: 14px;
      }
    }
  }
}

/* 品牌优势部分 */
.advantages-section {
  padding: 100px 0;
  position: relative;
  background: url('../assets/images/advantages-bg.png') center center no-repeat;
  background-size: cover;

  .container {
    position: relative;
    z-index: 2;
  }

  .section-title.advantages-title {
    color: #fff;
    
    &::after {
      background: url('../assets/images/title-bottom-bg.png') center/contain no-repeat;
    }
  }

  .advantages-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;

    @media (max-width: 992px) {
      grid-template-columns: 1fr;
      gap: 30px;
    }
  }

  .advantage-card {
    background: #fff;
    padding: 40px 30px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, #ed1c24, #ff6b6b);
      transform: scaleX(0);
      transition: transform 0.3s ease;
    }

    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 10px 40px rgba(237, 28, 36, 0.15);

      &::before {
        transform: scaleX(1);
      }

      .advantage-icon {
        transform: scale(1.1);
      }
    }

    .advantage-icon {
      width: 60px;
      height: 60px;
      margin-bottom: 25px;
      transition: transform 0.3s ease;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .advantage-title {
      font-size: 20px;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
      line-height: 1.4;
      text-align: left;
    }

    .advantage-desc {
      font-size: 15px;
      color: #666;
      line-height: 1.8;
      text-align: left;
    }
  }
}

/* 媒体中心部分 */
.media-section {
  padding: 100px 0;
  background: #fff;
  .container {
    padding: 0;
  }
  .media-content {
    display: flex;
    align-items: center;
    gap: 60px;
    margin-bottom: 60px;
    background: #F6F6F6;
    padding: 30px 50px;

    @media (max-width: 992px) {
      flex-direction: column;
      gap: 40px;
    }

    @media (max-width: 768px) {
      gap: 0;
      padding: 0;
      margin-bottom: 40px;
    }
  }

  .media-left {
    flex: 1;

    @media (max-width: 768px) {
      max-height: 200px;
      overflow: hidden;
    }

    img {
      width: 100%;
      height: auto;
      display: block;

      @media (max-width: 768px) {
        object-fit: cover;
        height: 200px;
      }
    }
  }

  .media-right {
    flex: 1;

    @media (max-width: 768px) {
      padding: 20px 15px;
      background: #F6F6F6;
    }

    .media-title {
      font-size: 28px;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
      line-height: 1.4;

      @media (max-width: 768px) {
        font-size: 18px;
        margin-bottom: 10px;
      }
    }

    .media-date {
      font-size: 14px;
      color: #999;
      margin-bottom: 20px;

      @media (max-width: 768px) {
        font-size: 12px;
        margin-bottom: 12px;
      }
    }

    .media-desc {
      font-size: 16px;
      color: #666;
      line-height: 1.8;
      margin-bottom: 30px;

      @media (max-width: 768px) {
        font-size: 14px;
        line-height: 1.6;
        margin-bottom: 15px;
      }
    }

    .media-link {
      display: inline-block;
      color: #ed1c24;
      font-size: 16px;
      font-weight: 500;
      text-decoration: none;
      transition: all 0.3s ease;

      @media (max-width: 768px) {
        font-size: 13px;
      }

      &:hover {
        transform: translateX(5px);
      }
    }
  }

  .media-loading, .media-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    margin-bottom: 60px;
    
    .loading-spinner {
      width: 50px;
      height: 50px;
      border: 4px solid #f3f3f3;
      border-top: 4px solid #ed1c24;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin-bottom: 20px;
    }
    
    p {
      color: #666;
      font-size: 16px;
    }
  }
  
  .media-empty {
    p {
      color: #999;
    }
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .media-more {
    text-align: center;

    .more-btn {
      padding: 14px 50px;
      background: #ed1c24;
      color: #fff;
      border: none;
      border-radius: 30px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: darken(#ed1c24, 10%);
        transform: translateY(-2px);
        box-shadow: 0 5px 15px rgba(237, 28, 36, 0.3);
      }
    }
  }
}

/* 合作伙伴部分 */
.partners-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #e3f2fd 0%, #f5f5f5 100%);

  .section-title {
    text-align: center;
    margin-bottom: 80px;
    
    &::after {
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .partners-header {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 60px;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 30px;
    }

    .partners-tabs {
      display: inline-flex;
      background: #f5f5f5;
      border-radius: 8px;
      overflow: hidden;
      padding: 0;

      .tab-btn {
        width: 150px;
        padding: 12px 0;
        background: transparent;
        border: none;
        font-size: 16px;
        font-weight: 500;
        color: #666;
        cursor: pointer;
        transition: all 0.3s ease;
        text-align: center;

        &:first-child {
          border-radius: 8px 0 0 8px;
          
          &.active {
            background: linear-gradient(270deg, #A31C20 0%, #DF0414 100%);
            color: #fff;
            border-radius: 8px 0 0 8px;
          }
        }
        
        &:last-child {
          border-radius: 0 8px 8px 0;
          
          &.active {
            background: linear-gradient(270deg, #A31C20 0%, #DF0414 100%);
            color: #fff;
            border-radius: 0 8px 8px 0;
          }
        }

        &:hover:not(.active) {
          background: rgba(0, 0, 0, 0.05);
        }
      }
    }

    .partners-arrows {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      gap: 10px;

      @media (max-width: 768px) {
        position: static;
        margin-top: 20px;
      }

      .arrow-btn {
        width: 40px;
        height: 40px;
        background: #fff;
        border: 1px solid #e0e0e0;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s ease;
        color: #666;

        &:hover {
          background: #ed1c24;
          border-color: #ed1c24;
          color: #fff;
        }

        &.prev svg {
          margin-right: 2px;
        }

        &.next svg {
          margin-left: 2px;
        }
      }
    }
  }

  .partners-content {
    .team-cards {
      display: flex;
      flex-wrap: wrap;
      gap: 40px;
      
      // 当只有一个卡片时，居中显示且宽度为50%
      &.single-card {
        justify-content: center;
        
        .single-team-card {
          flex: 0 0 50%;
          max-width: 600px; // 限制最大宽度
        }
      }
      
      @media (max-width: 992px) {
        flex-direction: column;
        
        &.single-card .single-team-card {
          flex: 0 0 100%; // 移动端恢复全宽
          max-width: 100%;
        }
      }

      .team-card {
        flex: 0 0 calc(50% - 20px);
        background: #fff;
        overflow: hidden;
        
        @media (max-width: 992px) {
          flex: 0 0 100%;
        }

        .team-card-inner {
          display: flex;
          height: 300px;
          align-items: stretch;
          
          @media (max-width: 768px) {
            flex-direction: column;
            height: auto;
          }
          
          // 给所有卡片的信息区域外层容器添加统一样式
          > div:not(.team-image) {
            flex: 1;
            display: flex;
            align-items: center;
          }
        }

        .team-image {
          position: relative;
          flex: 0 0 250px;
          
          @media (max-width: 768px) {
            flex: 1;
            height: 200px;
          }
          
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .team-label {
            position: absolute;
            top: 0;
            left: 0;
            background: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
            color: #fff;
            padding: 12px 28px;
            font-size: 18px;
            font-weight: 600;
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 0;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          }
        }

        .team-info {
          flex: 1;
          padding: 40px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          width: 100%;
          
          @media (max-width: 768px) {
            padding: 30px;
          }
          
          h3 {
            font-size: 22px;
            font-weight: bold;
            color: #333;
            margin-bottom: 8px;
          }

          .team-subtitle {
            font-size: 14px;
            color: #999;
            margin-bottom: 15px;
          }

          .team-desc {
            font-size: 15px;
            color: #666;
            line-height: 1.6;
          }
        }

        &.featured {
          .team-info-wrapper {
            flex: 1;
            background: #ed1c24;
            padding: 40px;
            display: flex;
            align-items: center;

            @media (max-width: 768px) {
              padding: 30px;
            }

            .team-info {
              padding: 0;

              h3, .team-desc {
                color: #fff;
              }

              .team-subtitle {
                color: rgba(255, 255, 255, 0.8);
              }
            }
          }
        }
      }
    }
    
    // 专家团轮播样式 - 一行两个
    .team-cards-carousel {
      display: flex;
      flex-wrap: wrap;
      gap: 40px;
      
      // 当只有一个卡片时，居中显示且宽度为50%
      &.single-card {
        justify-content: center;
        
        .single-team-card {
          flex: 0 0 50%;
          max-width: 600px; // 限制最大宽度
        }
      }
      
      @media (max-width: 992px) {
        flex-direction: column;
        
        &.single-card .single-team-card {
          flex: 0 0 100%; // 移动端恢复全宽
          max-width: 100%;
        }
      }

      .team-card {
        flex: 0 0 calc(50% - 20px);
        background: #fff;
        overflow: hidden;
        
        @media (max-width: 992px) {
          flex: 0 0 100%;
        }

        .team-card-inner {
          display: flex;
          height: 300px;
          align-items: stretch;
          
          @media (max-width: 768px) {
            flex-direction: column;
            height: auto;
          }
          
          // 给所有卡片的信息区域外层容器添加统一样式
          > div:not(.team-image) {
            flex: 1;
            display: flex;
            align-items: center;
          }
        }

        .team-image {
          position: relative;
          flex: 0 0 250px;
          
          @media (max-width: 768px) {
            flex: 1;
            height: 200px;
          }
          
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .team-label {
            position: absolute;
            top: 0;
            left: 0;
            background: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
            color: #fff;
            padding: 12px 28px;
            font-size: 18px;
            font-weight: 600;
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 0;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          }
        }

        .team-info {
          flex: 1;
          padding: 40px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          width: 100%;
          
          @media (max-width: 768px) {
            padding: 30px;
          }
          
          h3 {
            font-size: 22px;
            font-weight: bold;
            color: #333;
            margin-bottom: 8px;
          }

          .team-subtitle {
            font-size: 14px;
            color: #999;
            margin-bottom: 15px;
          }

          .team-desc {
            font-size: 15px;
            color: #666;
            line-height: 1.6;
          }
        }

        &.featured {
          .team-info-wrapper {
            flex: 1;
            background: #ed1c24;
            padding: 40px;
            display: flex;
            align-items: center;

            @media (max-width: 768px) {
              padding: 30px;
            }

            .team-info {
              padding: 0;

              h3, .team-desc {
                color: #fff;
              }

              .team-subtitle {
                color: rgba(255, 255, 255, 0.8);
              }
            }
          }
        }
      }
    }

    .institution-content {
      display: flex;
      background: #fff;
      overflow: hidden;

      @media (max-width: 992px) {
        flex-direction: column;
      }

      .institution-left {
        position: relative;
        flex: 0 0 500px;

        @media (max-width: 992px) {
          flex: 1;
          min-height: 300px;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .institution-label {
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(255, 255, 255, 0.15);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          color: #fff;
          padding: 14px 32px;
          font-size: 20px;
          font-weight: 600;
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 0;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
      }

      .institution-right {
        flex: 1;
        padding: 60px;
        background: #f8f9fa;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;

        @media (max-width: 768px) {
          padding: 40px 30px;
        }

        h3 {
          font-size: 28px;
          font-weight: bold;
          color: #333;
          margin-bottom: 10px;
        }

        .institution-location {
          font-size: 16px;
          color: #999;
          margin-bottom: 30px;
        }

        .institution-desc {
          font-size: 16px;
          color: #666;
          line-height: 1.8;
          margin-bottom: 40px;
        }

        .institution-dots {
          display: flex;
          gap: 10px;

          .dot {
            width: 10px;
            height: 10px;
            background: #ddd;
            border-radius: 50%;
            cursor: pointer;
            transition: all 0.3s ease;

            &.active {
              background: #ed1c24;
              width: 30px;
              border-radius: 5px;
            }
          }
        }
      }
    }
    
    // 加载状态和无数据状态样式
    .loading-partners,
    .no-data {
      text-align: center;
      padding: 60px 20px;
      color: #999;
      font-size: 16px;
    }
  }
}
</style>